module.exports = __webpack_public_path__ + "static/hero_pc-4eac610d09cbe96155478784a80b8905.png";